// extracted by mini-css-extract-plugin
export default {"ModelContainer":"upgrade_ModelContainer__89ex4","CameraModalContainer":"upgrade_CameraModalContainer__qOsnM","modalHeight":"upgrade_modalHeight__8-Rn7"};